import React, { FC } from 'react';
import LazyLoadComponent from '@lib/lazy-component';
import Component, { Props as ComponentProps } from './index';
import Placeholder from './placeholder';

export const LazyComponent: FC<ComponentProps> = (props) => (
  <LazyLoadComponent
    {...props}
    component={Component}
    placeholder={Placeholder}
  />
);

export default LazyComponent;
